import { RootState } from 'configs/redux';

export const examSessionSelector = (state: RootState) => state.examSession;
